import classNames from 'classnames/bind';
import React from 'react';

import { BrandAssets } from './BrandAssets/BrandAssets';
import { ContactStructuredData } from './ContactStructuredData/ContactStructuredData';
import { OurOffices } from './OurOffices/OurOffices';
import { AnimatedPath } from '@components/AnimatedPath/AnimatedPath';
import { ContactForm } from '@components/ContactForm/ContactForm';
import { Image } from '@components/Image/Image';
import { Head } from '@components/Layout/Head';
import { ContactBoxes } from '@components/Pages/Contact/ContactBoxes/ContactBoxes';
import { Section } from '@components/Section/Section';
import { SmallTitle } from '@components/SmallTitle/SmallTitle';
import { Text } from '@components/Text/Text';
import { trackContactFormSubmit } from '@gaEvents';

import styles from './Contact.module.scss';
import mapImage from './map.png';

const cx = classNames.bind(styles);

export const Contact: React.FC = () => (
  <>
    <Head
      description="CDN77 is a Content Delivery Network provider that offers transparent,
        fair and flexible solution and pricing. Contact us, we'd love to hear from you."
      title="Contact us"
    />
    <ContactStructuredData />
    <Section padding={{ top: 170, bottom: 120 }} tag="header">
      <Text
        align="center"
        className="mb-4"
        color="gray900"
        display="block"
        size={56}
        tag="h1"
        weight="bold"
      >
        Contact us
      </Text>
      <AnimatedPath align="center" delayMs={0} durationMs={500} height={60} />
      <ContactBoxes />
    </Section>
    <Section padding={{ top: 0, bottom: 120 }}>
      <div className={styles.contactBox}>
        <div className={styles.formWrapper}>
          <SmallTitle className="mb-2" color="blue">
            Message us
          </SmallTitle>
          <Text
            align="center"
            className="mb-6"
            color="gray900"
            display="block"
            size={30}
            tag="h2"
            weight="bold"
          >
            How can we help you?
          </Text>
          <ContactForm
            id="contact page form"
            subject="Contact Form"
            submitButtonPosition="center"
            submitButtonText="Send message"
            target="support"
            textarea={{
              label: 'Message',
            }}
            onSuccess={() => {
              trackContactFormSubmit('contact', 'Contact Form');
            }}
          />
        </div>
      </div>
    </Section>
    <Section className={styles.mapSection} padding={{ top: 90, bottom: 120 }} theme="tiles">
      <Text align="left" className="mb-6" color="gray900" size={44} tag="h2">
        Our offices
      </Text>
      <OurOffices />
      <div className={styles.map}>
        {['London', 'Prague'].map(city => (
          <div key={city} className={cx('pin', city.toLowerCase())}>
            {city}
          </div>
        ))}
        <Image alt="" height={1197} src={mapImage} width={1872} />
      </div>
    </Section>
    <Section id="assets" padding={{ top: 150, bottom: 120 }}>
      <Text align="center" className="mb-7" color="gray900" display="block" size={44} tag="h2">
        Brand assets
      </Text>
      <BrandAssets />
    </Section>
  </>
);
